import React from "react";
import classNames from "classnames";

import "./styles.styl";

export default function InputCheckbox(props) {
  let {
    className,
    id,
    name,
    value,
    placeholder,
    label,
    children,
    errors,
    onChanges,
    ...rest
  } = props;

  id = id || name;
  label = label || children;
  const checked = !!value;
  const checkedProp = onChanges ? "checked" : "defaultChecked";

  return (
    <div
      className={classNames("input-checkbox", className, {
        "is-checked": value,
        "has-errors": errors,
      })}
      {...rest}
    >
      <div className="input-checkbox__checkbox-container">
        <input
          id={id}
          className="obergudt-checkbox"
          type="checkbox"
          name={name}
          value="on"
          onChange={onChanges}
          {...rest}
          {...{ [checkedProp]: checked }}
        />
        <div className="input-checkbox__check" />
      </div>

      {label && (
        <label htmlFor={id} className="input-checkbox__label">
          {label}
        </label>
      )}
    </div>
  );
}
